<template>
	<section>
		<h3 class="dotted-title">
			<span>
				Add New User
			</span>
		</h3>

		<el-form label-position="top"
		         label-width="10px">
			<el-form-item label="Username">
				<el-select v-model="addUserForm.user_id"
				           value-key="username"
				           filterable
				           remote
				           placeholder="Search by username..."
				           :remote-method="search"
				           loading-text="Loading..."
				           :loading="addUserForm.loading">
					<el-option v-for="item in addUserForm.users"
					           :key="item.id"
					           :label="item.username"
					           :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="Role">
				<el-radio-group v-model="addUserForm.role">
					<el-radio label="user"
					          border></el-radio>
				</el-radio-group>
			</el-form-item>

			<el-form-item>
				<el-button round
				           type="success"
				           size="medium"
				           v-if="addUserForm.role && addUserForm.user_id"
				           @click="addUser"
				           :loading="addUserForm.sending">
					Add
				</el-button>
			</el-form-item>
		</el-form>

		<h3 class="dotted-title">
			<span>
				All Users
			</span>
		</h3>

		<user v-for="(item, index) in users"
		           :list="item"
		           :role="item.role"
		           :key="item.id"
		           @delete-user="users.splice(index, 1)"></user>
	</section>
</template>

<script>
import User from '../components/User.vue';

export default {
    components: { User },

    data() {
        return {
            addUserForm: {
                user_id: null,
                users: [],
                role: 'user',
                sending: false,
                loading: false,
            }, 
            
            users: []
        };
    },

    created() {
        this.getUsers();
    },

    methods: {
        getUsers() {
            app.$Progress.finish();
            app.$Progress.start();
            this.addUserForm.users = [];

            axios
                .get(`/channels/${Store.page.channel.temp.id}/users`)
                .then(response => {
                    this.users = response.data.data;
                    app.$Progress.finish();
                })
                .catch(error => {
                    app.$Progress.fail();
                });
        },

        search: _.debounce(function(query) {
            if (!query.trim()) return;
            this.addUserForm.loading = true;

            axios
                .get('/search', {
                    params: {
                        type: 'Users',
                        keyword: query
                    }
                })
                .then(response => {
                    this.addUserForm.users = response.data.data;
                    this.addUserForm.loading = false;
                })
                .catch(error => {
                    this.addUserForm.loading = false;
                });
        }, 600),

        addUser() {
            this.addUserForm.sending = true;

            axios
                .post(`/channels/${Store.page.channel.temp.id}/users`, {
                    user_id: this.addUserForm.user_id,
                    role: this.addUserForm.role
                })
                .then(() => {
                    this.addUserForm.user_id = null;
                    this.addUserForm.role = 'moderator';

                    this.getUsers();
                    this.addUserForm.sending = false;
                })
                .catch(() => {
                    this.addUserForm.sending = false;
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ModeratorPanelUsers.vue